import { Component, input } from '@angular/core';
import { SolarPanelsResultOverviewRendering } from '@feh/solar-panels-models';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import { SafePipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-solar-panels-result-overview-map',
  standalone: true,
  templateUrl: './solar-panels-result-overview-map.component.html',
  styleUrls: [
    './solar-panels-result-overview-map.component.ed.scss',
    './solar-panels-result-overview-map.component.essent.scss',
  ],
  imports: [SafePipe, ScFieldValuePipe],
})
export class SolarPanelsResultOverviewMapComponent {
  readonly rendering = input.required<SolarPanelsResultOverviewRendering>();
  readonly mapUrl = input.required<string>();
}
